<template>
    <div class="login">
        <div v-if="browser" class="browserf-main">
            <div class="browser">
                <p>您的浏览器不支持投屏，为了你的体验，建议使用谷歌或火狐浏览器</p>
            </div>
        </div>
        <div v-else="" class="login-main">
            <!--backgrounde-->
            <div class="bg-icon">
                <div v-for="(x, index) in 2" :key="index" class="bg-icon-all clearfix">
                    <img v-for="(n, index1) in bg" :key="'img1-' + index1" :src="n" class="bg-icons">
                    <img v-for="(n, index1) in bg" :key="'img2-' + index1" :src="n" class="bg-icons">
                    <img v-for="(n, index1) in bg" :key="'img3-' + index1" :src="n" class="bg-icons">
                    <img v-for="(n, index1) in bg" :key="'img4-' + index1" :src="n" class="bg-icons">
                </div>
            </div>
            <!--login content-->
            <div class="login-container">
                <div class="login-bar">
                    <div v-for="(n, index) in test" :key="'bg-img-' + index" 
                         :class="n.show == true ? 'isside':'' " 
                         class="login-bar-side"
                         @click="clickThis(index)">
                        <img :src="n.img" alt="">
                        <p>{{ n.text }}</p>
                    </div>
                </div>
                <div ref="loginContent" class="login-content">
                    <div v-for="(n, index) in test" v-show="n.show" :key="'auth-' + index" class="login-content-main">
                        <div v-if="index == 0" class="first">
                            <p>欢迎使用云班课投屏</p>
                            <p>请在手机云班课中点击投屏按钮</p>
                            <p>并在下方输入四位连接码</p>
                            <div class="wrong clearfix">
                                <span v-if="wrong">!</span>
                                <p v-if="wrong">连接码无效，请重试</p>
                            </div>
                            <div class="login-content-inp clearfix">
                                <div v-for="(x, inputIndex) in num" 
                                     :key="'num-input-' + inputIndex"
                                     :class=" x.class ? 'hasBorder' : '' "
                                     class="inp-text"
                                     v-text="x.number">
                                </div>
                            </div>
                        </div>

                        <div v-else-if="index == 1" class="seconde">
                            <div class="qr-code">
                                <div class="qr-title">扫码投屏</div>
                                <div class="qr-image">
                                    <div class="qr-image-src">
                                        <div v-if="expires" @click="regain"></div>
                                        <img :src="userQrCodeSrc.imageDataURL">
                                    </div>
                                    <p v-text="qrText1"></p>
                                    <p v-text="qrText2"></p>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="index == 2" class="seconde">
                            <div class="qr-code">
                                <div class="qr-title">云班课账号密码登录</div>
                                <div class="login-form">
                                    <!-- {{userWrong}} -->
                                    <div class="acc-wrong">
                                        <div v-if="accWrong">
                                            <span>!</span>
                                            <p>{{ accWrong }}</p>
                                        </div>
                                    </div>
                                    <div ref="username" 
                                         :class="usernames ?'usernames1' :'usrnames'" 
                                         class="form-user clearfix">
                                        <input v-model="username" placeholder="邮箱/手机" type="text" @focus="hasFocus" @blur="hasBlur" />
                                    </div>
                                    <div ref="userpwd" :class="userpwds ? 'userpwds1' :'userpwds'" class="form-user clearfix">
                                        <input v-model="userpwd" type="password" placeholder="密码" @focus="isFocus" @blur="isBlur" />
                                    </div>
                                    <div style="text-align: right; padding-top: 30px;">
                                        <a class="blue" href="https://www.mosoteach.cn/web/index.php?c=passport&m=forget_password" target="_blank">忘记密码？</a>
                                    </div>
                                    <div class="login-submit" @click="submit">登录</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import io from 'socket.io-client';
import tool from '@/assets/scripts/tool.js';

import bg1 from '@/assets/image/bg1.png';
import bg2 from '@/assets/image/bg2.png';
import bg3 from '@/assets/image/bg3.png';
import bg4 from '@/assets/image/bg4.png';
import bg5 from '@/assets/image/bg5.png';
import bg6 from '@/assets/image/bg6.png';
import bg7 from '@/assets/image/bg7.png';
import bg8 from '@/assets/image/bg8.png';
import bg9 from '@/assets/image/bg9.png';
import bg10 from '@/assets/image/bg10.png';
import bg11 from '@/assets/image/bg11.png';
import bg12 from '@/assets/image/bg12.png';
import linkCode from '@/assets/image/link-code.png';
import qrCode from '@/assets/image/qr-code.png';
import screenCode from '@/assets/image/screen-icon.png';

export default {
    name: 'Login',
    inject: ['reload'],
    data: function() {
        return {
            $socket: null,
            qrText1: '在手机云班课中点击“投屏 - 扫码投屏”',
            qrText2: '扫一扫',
            browser: false,
            token: sessionStorage.getItem('__token'),
            nowExpires: '',
            accWrong: '',
            username: '',
            userpwd: '',
            numCode:'',
            usernames:'',
            userpwds:'',
            expires: '',
            wrong: false,
            userQrCodeSrc: [],
            authCode: [],
            users: [],
            bg: [
                bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10, bg11, bg12
            ],
            test: [{
                id: 0,
                text: '连接码投屏',
                content: '内容1',
                show: true,
                img: linkCode
            }, {
                id: 1,
                text: '扫码投屏',
                content: '内容2',
                show: false,
                img: qrCode
            }, {
                id: 2,
                text: '账号密码投屏',
                content: '内容3',
                show: false,
                img: screenCode
            }],
            num: [{
                id: 0,
                number: '',
                class: true
            }, {
                id: 1,
                number: '',
                class: ''
            }, {
                id: 2,
                number: '',
                class: ''
            }, {
                id: 3,
                number: '',
                class: ''
            }],
        };
    },

    computed: {
        getImage: function() {
            return this.$store.state.qrCodeSrc;
        },

        n0: function() {
            return this.getNumber(0);
        },

        n1: function() {
            return this.getNumber(1);
        },

        n2: function() {
            return this.getNumber(2);
        },

        n3: function() {
            return this.getNumber(3);
        },

        Swidth: function() {
            return window.screen.width;
        },

        Sheight: function() {
            return window.screen.height;
        }
    },

    watch: {
        numCode: function(val) {
            for(let i = 0; i < this.num.length; i++){
                this.num[i].number = val[i];
            };
            if(val.length === 0){
                this.num[0].class = true;
                this.num[1].class = false;
                this.num[2].class = false;
                this.num[3].class = false;
            }
            if(val.length === 1){
                this.num[1].class = true;
                this.num[0].class = false;
                this.num[2].class = false;
                this.num[3].class = false;
            }
            if(val.length === 2){
                this.num[2].class = true;
                this.num[1].class = false;
                this.num[0].class = false;
                this.num[3].class = false;
            }
            if(val.length === 3){
                this.num[3].class = true;
                this.num[2].class = false;
                this.num[1].class = false;
                this.num[0].class = false;
            }
            if(val.length === 4){
                this.num[3].class = false;
                this.num[1].class = false;
                this.num[2].class = false;
            }
        }
    },

    created: function() {
        let currentSocketId = null;

        this.$socket = io(process.env.VUE_APP_SOCKET_IO_ENDPOINT, {
            transports: ['websocket'],
            reconnection: false
        });

        // 连接到socket.Io
        this.$socket.on('connect', () => {
            console.log('connected to socket.io server:', this.$socket.id);
            currentSocketId = this.$socket.id;
        });

        this.$socket.on('disconnect', () => {
            console.log('disconnect from socket.io server:', currentSocketId);
            currentSocketId = null;
        });
        
        // 二维码被扫描
        this.$socket.on('passport.qrcode-binded', (omsData) => {
            if (omsData.result) {
                this.resetSetItem('__token', omsData.token);
                this.$router.push({path: '/stage'});
            } else {
                // Show error message
            }
        });

        this.handleIncomingFromWeb();
        
        window.addEventListener('keyup' , this.handleIncoming);
        // console.log(this.Swidth,this.Sheight)

    },

    mounted: function() {
        
    },

    destroyed: function() {
        window.removeEventListener('keyup', this.handleIncoming);
        if (this.$socket) this.$socket.disconnect();
    },

    
    methods: {
        // 浏览器是否兼容
        navigator(){
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            if(!tool.isSupportedBrowsers(userAgent)) {
                // Nothing to do
                this.browser = true;
            } else {
                // show the browser screen
                this.browser = false;
                this.token = sessionStorage.getItem('__token');
                if(token){
                    this.$router.push({path:'/stage'});
                }else{
                    this.$router.push({path: '/'});
                }
            }
        },

        handleIncoming: function(e) {
            if (this.test[0].show) {
                // console.log(e.keyCode);
                // 监听键盘输入情况
                let keyCode = e.keyCode;
                if (96 <= keyCode && keyCode <= 105) keyCode -= 48;

                if (keyCode >= 48 && keyCode <= 57) {
                    if (this.numCode.length < 4) {
                        this.numCode += String.fromCharCode(keyCode);
                    }
                } else if (keyCode === 8) {
                    if (this.numCode.length > 0) {
                        this.numCode = this.numCode.substring(0, this.numCode.length - 1);
                    }
                }

                if (this.numCode.length === 4) {
                    let authCodes = this.numCode;
                    setTimeout(() => {
                        this.$socket.emit('passport.auth-by-code', {'code': authCodes}, (ackData) => {
                            // console.log(ackData);
                            this.wrong = !ackData.result;
                            if (ackData.result) {
                                this.resetSetItem('__token', ackData.token);
                                this.$socket.emit('common.screenSize', {'height': this.Sheight,'width': this.Swidth});
                                this.$router.push({path: '/stage'});
                                this.numCode = '';
                            } else {
                                this.numCode = '';
                            }
                        });
                    },300);
                }
            }
            
            if (this.test[2].show) {
                // 回车键登录
                if(e.keyCode === 13){
                    var pattern0 = /0?(1)[0-9]{10}/;
                    var pattern1 = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
                    if (this.username == '') {
                        this.accWrong = '请输入账号';
                    } else if (this.userpwd == '') {
                        this.accWrong = '请输入密码';
                    } else if (!pattern0.test(this.username) && !pattern1.test(this.username)) {
                        this.accWrong = '账号格式不正确，请重新输入';
                    } else {
                        this.userWrong = '';
                        //监听服务器消息(账号密码消息)
                        this.$socket.emit('passport.auth-by-password', {
                            account: this.username,
                            password: this.userpwd
                        }, (ackData) => {
                            console.log(ackData);
                            if (ackData.result) {
                                this.resetSetItem('__token', ackData.token);
                                this.$socket.emit('common.screenSize', {'height': this.Sheight,'width': this.Swidth});
                                this.$router.push({path: '/stage/username-password-login'});
                            } else {
                                this.accWrong = '用户名或密码错误，请重新输入';
                            }
                        });
                    }   
                }   
            }
        },

        hasFocus() {
            this.usernames = true;
        },

        hasBlur(){
            this.usernames = false;
        },

        isFocus(){
            this.userpwds = true;
        },

        isBlur(){
            this.userpwds = false;
        },
        
        // 拆分键盘码
        getNumber: function(index) {
            if (this.numCode.length > index) {
                return this.numCode.charAt(index); 
            } else {
                return '';
            }
        },

        // 点击二维码图标现实二维码登陆信息
        clickThis: function(index) {
            for(var i = 0; i < this.test.length; i++) {
                this.test[i].show = false;
            }
            this.test[index].show = true;

            if(index == 1) {
                this.handleqrCode();
            }

        },
        
        handleqrCode: function() {
            this.$socket.emit('passport.request-qrcode', null, (ackData) => {
                this.userQrCodeSrc = ackData;

                let nowExpires;
                // 计时器计算过期时间
                let timer = setInterval(() => {
                    nowExpires = Math.round(Date.now() / 1000);
                    if (nowExpires >= this.userQrCodeSrc.expires) {
                        this.expires = true;
                        clearInterval(timer);
                    }
                }, 1000);
            });
        },

        regain: function() {
            this.expires = false;
            this.handleqrCode();
        },

        // 点击登陆按钮登陆
        submit: function() {
            var pattern0 = /0?(1)[0-9]{10}/;
            var pattern1 = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            if (this.username == '') {
                this.accWrong = '请输入账号';
            } else if (this.userpwd == '') {
                this.accWrong = '请输入密码';
            } else if (!pattern0.test(this.username) && !pattern1.test(this.username)) {
                this.accWrong = '账号格式不正确，请重新输入';
            } else {
                this.userWrong = '';
                //监听服务器消息(账号密码消息)
                this.$socket.emit('passport.auth-by-password', {
                    account: this.username,
                    password: this.userpwd
                }, (ackData) => {
                    if (ackData.result) {
                        this.resetSetItem('__token', ackData.token);
                        this.$socket.emit('common.screenSize', {'height': this.Sheight,'width': this.Swidth});
                        this.$router.push({path: '/stage/username-password-login'});
                    } else {
                        this.accWrong = '用户名或密码错误，请重新输入';
                    }
                });
            }
        },

        handleIncomingFromWeb: function() {
            let signature = this.getQueryString('signature');
            let ts = this.getQueryString('ts');
            let accessId = this.getQueryString('accessId');
            // console.log(signature,ts,accessId);
            // if (!token) return; 
            if (signature && ts && accessId) {
                this.$socket.emit('passport.auth-by-psignature', {
                    signature: signature,
                    ts: ts,
                    accessId: accessId
                }, (ackData) => {
                    console.log(ackData);
                    if (!ackData.result) return;
                    this.resetSetItem('__token', ackData.token);
                    this.$socket.emit('common.screenSize', {'height': this.Sheight,'width': this.Swidth});
                    this.$router.push({path: '/stage/username-password-login'});
                });
            }
        },

        getQueryString: function(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
            var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
            if(r != null) return  unescape(r[2]); return null;
        }
    }
};
</script>

<style scoped>
    .browser {
        color: #ffffff;
        font-size: 36px;
    }

    .login-main {
        min-width: 1280px;
        min-height: 720px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        box-sizing: border-box;
        background: linear-gradient(45deg, #110E0E 0%, #0D151B 24%, #1B2A37 49%, #517FA4 100%);
        z-index: -2;
        overflow: visible;
    }
    
    .bg-icon {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        overflow: hidden;
    }

    .bg-icon-all{
        /* animation: bgMove 400s linear infinite; */
    }
    
    .bg-icons {
        width: 120px;
        height: 120px;
        float: left;
        margin: 50px 100px;
        opacity: 0.5;
        transform: rotate(45deg)
    }
    
    @keyframes bgMove {
        from {
            transform: translate(0, 0) rotate(15deg);
        }
        to {
            transform: translate(0, -500px) rotate(15deg);
        }
    }
    
    .login-container {
        width: 100%;
        height: 100%;
        padding-right: 360px;
        box-sizing: border-box;
    }
    
    .login-bar {
        width: 240px;
        min-height: 720px;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow-y: auto;
    }
    
    .login-bar-side {
        width: 100%;
        height: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    
    .isside {
        background: rgba(0, 0, 0, 0.3);
    }
    
    .login-bar-side > img:nth-of-type(1) {
        display: block;
        width: 80px;
        height: 80px;
    }
    
    .login-bar-side > p {
        color: #FFFFFF;
        font-size: 24px;
        margin-top: 30px;
    }
    
    .login-content {
        width: 100%;
        height: 100%;
    }
    
    .login-content-main {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    
    .first {
        margin-left: 120px;
    }
    
    .wrong {
        margin: 56px 2px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 24px;

    }
    
    .wrong>span {
        display: block;
        width: 24px;
        height: 24px;
        background: #fc4848;
        border-radius: 50%;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 24px;
        margin-right: 10px;
        float: left;
        font-family: 'Arial';
        text-align: center;
    }
    
    .wrong>p {
        line-height: 25px;
        font-size: 24px;
        color: #fc4848;
        float: left;
    }

    .acc-wrong {
        margin: 20px 0 12px;
    }

    .acc-wrong > div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0px 0 12px;
        height: 20px;
    }

    .acc-wrong > div > span {
        display: block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        font-size: 14px;
        background: #fc4848;
        color: #FFFFFF;
        line-height: 19px;
        margin-right: 10px;
        font-family: 'Arial';
        text-align: center;
    }
    
    .acc-wrong > div > p {
        font-size: 18px;
        color: #fc4848;
    }
    
    .first>p {
        color: #ffffff;
        text-align: left;
        margin-bottom: 130px;
    }
    
    .first>p:nth-of-type(1) {
        font-size: 24px;
    }
    
    .first>p:nth-of-type(2),
    .first>p:nth-of-type(3) {
        font-size: 36px;
        margin: 10.7px 0;
    }
    
    .inp-text {
        width: 140px;
        height: 140px;
        border-radius: 24px;
        background: #FFFFFF;
        float: left;
        margin: 0 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 80px;
        /* border: 6px solid #00bbdd; */
        box-sizing: border-box;
    }

    .hasBorder{
        border: 2px solid #5a9bdc;
        box-shadow: 0px 0px 20px 6px #5a9bdc;
    }

    .inp-text:nth-of-type(1) {
        margin-left: 0;
    }
    
    .inp-text:nth-of-type(4) {
        margin-right: 0;
    }
    
    /*qrcode*/
    
    .seconde {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    
    .qr-code {
        width: 480px;
        height: 600px;
        border-radius: 8px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 30px;
    }
    
    .qr-title {
        font-size: 24px;
        padding: 38px 0;
        text-align: center;
        color: #323232;
        border-bottom: 1px solid #cccccc;
    }
    
    .qr-image {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    
    .qr-image-src {
        margin-top: 50px;
        width: 280px;
        height: 280px;
        background: #CCCCCC;
        position: relative;
    }

    .qr-image-src > div {
        width: 100%;
        height: 100%;
        background: rgba(0255, 255, 255, 0.7);
        background: url(../assets/image/screen_icon_coderenovate.png) no-repeat;
        background-size: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        cursor: pointer;
    }
    
    .qr-image>p {
        width: 340px;
        font-size: 18px;
        line-height: 30px;
        color: #333333;
        text-align: center;
        margin-top: 20px;
    }
    
    .qr-image>p:nth-of-type(2) {
        margin-top: 6px;
    }
    /*form*/
    
    .login-form {
        display: flex;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
    }
    
    .form-user {
        border: 1px solid #CCCCCC;
        border-radius: 2px;
        margin-top: 50px;
    }
    
    .usrnames{
        margin: 0;
        background: url(../assets/image/icon_account.png) no-repeat;
        background-size: 24px 24px;
        padding-left: 65px;
        background-position-y: 50%;
        background-position-x: 20px;
    }

    .usernames1{
        margin: 0;
        background: url(../assets/image/icon_account_blur.png) no-repeat;
        background-size: 24px 24px;
        padding-left: 65px;
        background-position-y: 50%;
        background-position-x: 20px;
        border: 1px solid #00BBDD;
    }
    
    .userpwds{
        background: url(../assets/image/icon_lock.png) no-repeat;
        background-size: 24px 24px;
        padding-left: 65px;
        background-position-y: 50%;
        background-position-x: 20px;
    }

    .userpwds1{
        background: url(../assets/image/icon_lock_blur.png) no-repeat;
        background-size: 24px 24px;
        padding-left: 65px;
        background-position-y: 50%;
        background-position-x: 20px;
        border: 1px solid #00BBDD;
    }
    
    .form-user>input {
        height: 63px;
        width: 323px;
        font-size: 18px;
        float: left;
        border: none;
    }
    
    .login-form>p {
        width: 100%;
        font-size: 18px;
        color: #00BBDD;
        text-align: right;
        margin-top: 30px;
    }
    
    a.blue,
    a.blue:link,
    a.blue:visited,
    a.blue:hover,
    a.blue:active {
        font-size: 18px;
        color: #00BBDD;
    }

    .login-submit {
        width: 420px;
        height: 60px;
        background: #00BBDD;
        color: #FFFFFF;
        line-height: 60px;
        text-align: center;
        margin-top: 60px;
        font-size: 18px;
    }
    
    .full-screen {
        width: 125px;
        height: 60px;
        position: fixed;
        bottom: 50px;
        left: 0;
        background: rgba(0, 0, 0, 1);
        z-index: 9;
    }
</style>